import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';
import { ThemeProps } from '@theme/base';
import { ExploreResorts } from '@components/explore-resorts';
import { OffersGroup } from '@components/common/offers';
import { Climate } from '@components/climate';
import { ProductPackageGroup } from '@components/product/product-package/ProductPackageGroup';

export const StyledProductPackageGroup = styled(ProductPackageGroup)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const StyledOffersGroup = styled(OffersGroup)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const StyledExploreResorts = styled(ExploreResorts)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const StyledClimate = styled(Climate)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: theme.custom.spacing.xxxLarge
  }
}));

export const CMSComponentsContainer = styled.div({
  ['[data-testid="mh-benefits-row"]']: {
    marginBottom: 0
  }
});
